import { useStore } from "@/store";

class ExperienceClass {
  constructor() {}

  get store() {
    return useStore.getState();
  }

  showConfetti() {
    this.store.experience.setShowConfetti(true);
  }

  showDialog(dialogId: string) {
    this.store.dialog.setActiveDialog(dialogId);
  }

  showWelcomeDialog() {
    this.showDialog("welcome");
  }

  setExplicitPlaylistMessage(params: { message: string; timeout: number }) {
    this.store.playlists.setExplicitPlaylistMessage(params.message);
    setTimeout(() => {
      this.store.playlists.setExplicitPlaylistMessage(null);
    }, params.timeout || 1800);
  }
}

export const Experience = new ExperienceClass();
